import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const plaidItemsQueryAtom = createQueryAtomFactory(
  'finance.plaidItems',
  (_: void) => ({
    plaidItems: {
      __scalar: true,
    },
  }),
  {
    select: (data) => ({
      plaidItems:
        data?.plaidItems?.map((it) => ({
          id: it?.id,
          institution: it?.institution,
        })) ?? [],
    }),
  },
);
